export default {
  MfaHelpLink__NEED_HELP: "Need help?",
  MfaHelpLink__NEED_HELP_ARIA: "Need help? opens new window",
};
